export default __webpack_public_path__ + "static/media/notif.09dcacd6.svg";